import React from 'react';
import { Plus, Filter, Download } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const EvaluationHeader = ({
  setShowFilters,
  showFilters,
  setShowModal
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* En-tête avec statistiques */}
      <div className="bg-gradient-to-r from-[#202654] to-[#202654]/90 px-6 py-8">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex items-center text-white">
            <button
              onClick={() => navigate(-1)}
              className="mr-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 transition-all duration-200 backdrop-blur-sm"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
        <div>
              <h1 className="text-2xl font-bold">Gestion des Évaluations</h1>
              <p className="mt-1 text-blue-100">Gérez les contrôles, devoirs et leurs notes</p>
        </div>
      </div>
          <div className="mt-4 md:mt-0 flex flex-col sm:flex-row sm:space-x-3 space-y-3 sm:space-y-0">
            <button
              onClick={() => setShowFilters(!showFilters)}
              className="inline-flex items-center justify-center px-4 py-2 border border-white/20 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
            >
              <Filter className="h-4 w-4 mr-2" />
              Filtres
            </button>
            <button
              className="inline-flex items-center justify-center px-4 py-2 border border-white/20 rounded-md shadow-sm text-sm font-medium text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
            >
              <Download className="h-4 w-4 mr-2" />
              Exporter
            </button>
          <button
            onClick={() => setShowModal(true)}
              className="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-white/10 hover:bg-white/20 backdrop-blur-sm transition-all duration-200"
          >
              <Plus className="h-5 w-5 mr-2" />
            Nouvelle Évaluation
          </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EvaluationHeader; 